// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class BlogFeed extends React.Component {
	render() {
		const { postsData } = this.props
		const items = postsData.items
		let markup = []

		if ( items && Object.keys( items ).length ) {
			markup = Object.keys( items )
				.map( ( key, i ) => {
					let item = items[ key ]

					if ( i >= 3 ) {
						return null
					}

					return (
						<Link to={ item.url } className="facebook-post" key={ key }>
							<i className="icon-chevron-right" aria-hidden="true"></i>

							<div className="-inner">
								<header>
									<span className="-sub">{ item.date }</span>
								</header>

								{ item.image_url &&
									<div className="-image-wrap">
										<div className="-image">
											<img src={ item.image_url } alt="" />
										</div>
									</div>
								}

								<main>
									<div className="-text" dangerouslySetInnerHTML={ { __html: item.title } } />
								</main>
							</div>
						</Link>
					)
				})
		}

		markup = markup.filter( Boolean )

		return (
			<div className="facebook-feed">
				<header>
					<h2>News</h2>

					<p className="sub"><a href="https://www.facebook.com/faithfmaustralia/" target="_blank" rel="noopener">Follow us on Facebook</a></p>
				</header>

				<main>
					{ markup }
				</main>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let postsData = {}

	if ( state.page.byId.id_news ) {
		postsData = state.page.byId.id_news.posts
	} else if ( state.page.byId.id_blog ) {
		postsData = state.page.byId.id_blog.posts
	} else if ( state.page.byId.id_home ) {
		postsData = state.page.byId.id_home.posts
	}

	return {
		postsData: postsData
	}
}

export default connect( mapStateToProps )( BlogFeed )
